var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInfoWhiteFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58214 0 0 3.58214 0 8C0 12.4179 3.58214 16 8 16C12.4179 16 16 12.4179 16 8C16 3.58214 12.4179 0 8 0Z",
    fill: "#E3E3E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14648 4.85714C7.14648 5.08447 7.2368 5.30249 7.39757 5.46323C7.55834 5.62398 7.77638 5.71429 8.00374 5.71429C8.2311 5.71429 8.44914 5.62398 8.60991 5.46323C8.77068 5.30249 8.861 5.08447 8.861 4.85714C8.861 4.62981 8.77068 4.4118 8.60991 4.25105C8.44914 4.09031 8.2311 4 8.00374 4C7.77638 4 7.55834 4.09031 7.39757 4.25105C7.2368 4.4118 7.14648 4.62981 7.14648 4.85714ZM8.43237 6.85714H7.57511C7.49653 6.85714 7.43224 6.92143 7.43224 7V11.8571C7.43224 11.9357 7.49653 12 7.57511 12H8.43237C8.51095 12 8.57524 11.9357 8.57524 11.8571V7C8.57524 6.92143 8.51095 6.85714 8.43237 6.85714Z",
    fill: "#7F7EFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoWhiteFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info-white-filled.297a75db.svg";
export { ForwardRef as ReactComponent };